import {
  ActionMenu as SharedActionMenu,
  type ActionMenuItem as SharedActionMenuItem,
} from "@sylviq/ui-react-web/blocks/table";
import { useNavigate } from "@tanstack/react-router";

export interface ActionMenuItem {
  id: string;
  label: string;
  onSelect?: () => void;
  to?: string;
  href?: string;
  params?: Record<string, string>;
  search?: (previous: Record<string, unknown>) => Record<string, unknown>;
  disabled?: boolean;
  title?: string;
  ariaLabel?: string;
  busy?: boolean;
  busyLabel?: string;
}

interface ActionMenuProps {
  label: string;
  items: ActionMenuItem[];
  ariaLabel?: string;
  align?: "start" | "end";
}

/** Accounting's route-aware item model over the shared table action menu. */
export function ActionMenu({
  label,
  items,
  ariaLabel = label,
  align = "end",
}: ActionMenuProps) {
  const navigate = useNavigate();
  const adaptedItems: SharedActionMenuItem[] = items.map((item) => {
    if (item.href) {
      return {
        id: item.id,
        label: item.label,
        href: item.href,
        disabled: item.disabled,
        busy: item.busy,
        busyLabel: item.busyLabel,
        title: item.title,
        ariaLabel: item.ariaLabel,
      };
    }
    if (item.to) {
      const to = item.to;
      return {
        id: item.id,
        label: item.label,
        disabled: item.disabled,
        busy: item.busy,
        busyLabel: item.busyLabel,
        title: item.title,
        ariaLabel: item.ariaLabel,
        onSelect: () => {
          void navigate({
            to,
            params: item.params,
            search: item.search,
          } as never);
        },
      };
    }
    return {
      id: item.id,
      label: item.label,
      onSelect: item.onSelect,
      disabled: item.disabled,
      busy: item.busy,
      busyLabel: item.busyLabel,
      title: item.title,
      ariaLabel: item.ariaLabel,
    };
  });
  return (
    <SharedActionMenu
      label={label}
      items={adaptedItems}
      ariaLabel={ariaLabel}
      align={align}
    />
  );
}
